import { useEffect, useState } from "react";
import { useCookies } from "react-cookie";
import { useLocation } from "react-router-dom";
import { ExperimentGroup, UserExperiments } from "../../../helpers/const";
import { getStepIndex } from "../../../helpers/steps";
// eslint-disable-next-line import/no-unresolved
import { useAppDispatch, useAppSelector } from "@/store/store";
import ArrowCircleRight from "../../../img/svg/arrow-circle-right.svg?react";
import { getCalculatorSettingsThunk } from "../../../server/thunks/thunks";
import { UiActionCreators } from "../../../store/action-creators/uiActions";
import {
  selectDisplayName,
  selectExperimentGroup,
  selectIsOperator,
  selectNullableApplicationId,
  selectServerSettings,
} from "../../../store/selectors";
import { CalculatorType } from "../../Calculator/hooks";
import { CalculatorMobile } from "../../Calculator/mobile";
import { OperatorNavigation } from "../../OperatorNavigation";
import { Spinner, SpinnerColor, SpinnerSize } from "../../widgets/Spinner";
import { IGNORE_SCREENS } from "../lib/constants";
import {
  getAllUrlsForHeader,
  hideSubHeader,
  isSimpleHeader,
  showHeaderWithAmount,
} from "../lib/utils/headerHelpers";
import { CalculatorPanel } from "./CalculatorPanel";
import { LogoLink } from "./LogoLink";
import { ProgressBar } from "./ProgressBar";
import { UserAccountButton } from "./UserAccountButton";

export const Header = () => {
  const [cookies] = useCookies();

  const location = useLocation();

  const dispatch = useAppDispatch();

  const applicationId = useAppSelector(selectNullableApplicationId);
  const isAuth = useAppSelector((state) => state.authReducer.isAuth);
  const isOperator = useAppSelector(selectIsOperator);
  const displayName = useAppSelector(selectDisplayName);
  const serverSettings = useAppSelector(selectServerSettings);
  const addSumGroup = useAppSelector(
    selectExperimentGroup(UserExperiments.addSum)
  );

  const [showCalcMobile, setShowCalcMobile] = useState(false);
  const [showCabinetBtn, setShowCabinetBtn] = useState(false);

  const workingMode = serverSettings?.HeaderTextNewLK;
  const phone = serverSettings?.HeaderNumberNewLK;

  const hideCalculator =
    addSumGroup === ExperimentGroup.B &&
    Number(getStepIndex(location.pathname)) > 5;

  useEffect(() => {
    dispatch(UiActionCreators.showSideBarCalculator(false));
    setShowCalcMobile(false);
  }, [location.pathname, dispatch]);

  const isSmartCalculator = !cookies.term;

  useEffect(() => {
    if (!applicationId) return;

    dispatch(
      getCalculatorSettingsThunk({
        applicationId,
        useSmartCalculator: isSmartCalculator,
      })
    );
  }, [applicationId, isAuth, cookies.term, isSmartCalculator, dispatch]);

  useEffect(() => {
    const showUserAccountButton =
      IGNORE_SCREENS.indexOf(location.pathname) === -1;
    setShowCabinetBtn(showUserAccountButton);
  }, [location.pathname]);

  const showMobileCalculator = () => showCalcMobile;

  const isPageWithSimpleHeader = isSimpleHeader(location);
  const urls = getAllUrlsForHeader();

  return (
    <>
      <header className="header">
        <div
          className={`header-top ${isPageWithSimpleHeader ? "header-top-welcome" : ""}`}>
          <div className="container">
            <div className="row">
              <div
                className={`col-md-3 header-top-col-left ${isPageWithSimpleHeader ? "header-top-col-left-welcome" : ""}`}>
                <LogoLink />
              </div>
              {!isPageWithSimpleHeader && (
                <div className="col-md-9 header-top-col-right">
                  <a href={`tel:${phone}`} className="phone">
                    {phone}
                  </a>
                  <div className="time">
                    {workingMode}
                    {/* c 7:00 до 20:00 мск, <br/> */}
                    {/* без выходных (звонок платный) */}
                  </div>

                  {isOperator && (
                    <button
                      type="button"
                      className="btn btn_pink"
                      style={{
                        width: "200px",
                        flexDirection: "column",
                        gap: "10px",
                        height: "80px",
                      }}>
                      <span>Режим ограниченного доступа!</span>
                      <span>{displayName}</span>
                    </button>
                  )}

                  <UserAccountButton urls={urls}>
                    {({ loading, hidden, onClick }) => (
                      <button
                        type="button"
                        onClick={onClick}
                        className={`btn btn_primary_dark ${
                          showCabinetBtn && !hidden ? "" : "hidden-button"
                        }`}
                        data-testid="header-lk-button">
                        {!loading && <ArrowCircleRight />}
                        {loading && (
                          <Spinner
                            size={SpinnerSize.small}
                            color={SpinnerColor.white}
                          />
                        )}
                        <span className="md-hide">Личный кабинет</span>
                        <span className="md-visible">ЛК</span>
                      </button>
                    )}
                  </UserAccountButton>
                </div>
              )}
            </div>
          </div>
        </div>

        {!isPageWithSimpleHeader &&
          (location.pathname === "/registration" ||
          location.pathname === "/authorization" ? (
            <div className={`header-calc `}>
              <div className="container">
                <div className="row">
                  <ProgressBar />

                  {!hideCalculator && (
                    <div className={`col-md-6 header-calc-col-result mw-480 `}>
                      <CalculatorPanel
                        showButton={showCabinetBtn}
                        setShowCalcMobile={setShowCalcMobile}
                      />
                    </div>
                  )}

                  <div
                    className={`col-lg-12 md-visible ${
                      showMobileCalculator() ? "" : "md-hide"
                    }`}>
                    {showCalcMobile && (
                      <CalculatorMobile
                        calculatorType={CalculatorType.REGAUTH}
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>
          ) : (
            !hideSubHeader(location) && (
              <div className="header-calc">
                <div className="container">
                  <div className="row">
                    <ProgressBar />

                    {!hideCalculator && (
                      <div
                        className={`col-md-6 header-calc-col-result mw-480 ${
                          showHeaderWithAmount(location) ? "" : "md-hide"
                        }`}>
                        <CalculatorPanel
                          showButton={showCabinetBtn}
                          setShowCalcMobile={setShowCalcMobile}
                        />
                      </div>
                    )}

                    <div
                      className={`col-lg-12 md-visible ${
                        showMobileCalculator() ? "" : "md-hide"
                      }`}>
                      {showCalcMobile && (
                        <CalculatorMobile
                          calculatorType={CalculatorType.PRODUCT}
                        />
                      )}
                    </div>
                  </div>
                </div>
              </div>
            )
          ))}
      </header>
      {!isPageWithSimpleHeader && <OperatorNavigation />}
    </>
  );
};
